export default __webpack_public_path__ + "static/media/recurring-billing-img03.afa80ad2.png";